module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// ./~/bl/~/readable-stream/lib/internal/streams/stream-browser.js
// module id = 97
// module chunks = 73